<ng-container *ngIf="viewerState$ | async; let viewerState">
    <button *ngIf="viewerState.enabled"
            class="se-header-toolbar-button"
            mat-icon-button
            [matTooltip]="viewerState.tooltip"
            (click)="openViewer()">
        <mat-icon>{{ viewerState.icon }}</mat-icon>
    </button>
</ng-container>
